class WindowEventHelper {

	static add(name, handler) {
		if (window.addEventListener) {
			window.addEventListener(name, handler)
		} else {
			window.attachEvent(`on${name}`, handler)
		}
	}

	static remove(name, handler) {
		if (window.removeEventListener) {
			window.removeEventListener(name, handler)
		} else {
			window.detachEvent(`on${name}`, handler)
		}
	}

	static dispatch(name, value){
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, value);
    window.dispatchEvent(event)
  }
}

export default WindowEventHelper
